var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Form',{attrs:{"page-title":"Edit Menu","buttonName":"Update","businessId":_vm.businessId,"isInList":_vm.isInList,"model":_vm.model,"loading":_vm.loading},on:{"showAddChanged":function($event){return _vm.$emit('showAddChanged', $event)},"submit":_vm.submit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }